module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0042.jpg?v=b9414b2f";